import styled from "styled-components"
import { Link as DefaultLink } from '../../link/link'

export const Container = styled.div`
  width: 100%;

  .carousel .slide img {
    max-height: 526px;
    width: auto !important;
  }

  .carousel .control-dots {
    margin: 32px 0px;

    .dot {
      border-radius: 50px;
      height: 8px;
      width: 38px;
    }
  }

  @media (max-width: 768px) {
    display: flex;

    .carousel-root {
      width: 100%;
    }
  }
`

export const BannerContainer = styled.div`
  background-color: #00A687;
  padding: 32px 179px 72px 179px;

  @media (max-width: 768px) {
    padding: 32px;
  }
`

export const BannerWrapper = styled.div`
  align-items: center;
  display: flex;
  gap: 176px;
  justify-content: space-between;

  img {
    display: block;
    max-width: 100%;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 28px;
    padding: 0;
    margin-bottom: 32px;
  }
`

export const BannerContent = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  padding: 54px 0px;

  @media (max-width: 768px) {
    padding: 0;
    width: 100%;
  }
`

export const Title = styled.h4`
  color: #A6FF00;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    font-size: 24px;
    line-height: 27.58px;
  }
`

export const Description = styled.p`
  color: #FFFFFF;
  font-size: 24px;
  line-height: 27.58px;
  margin-bottom: 62px;

  strong {
    font-weight: bold;
  }

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 0;
  }
`

export const Link = styled(DefaultLink)`
  font-size: 24px;
  font-weight: 700;
  line-height: 27.58px;
  padding: 8px 79px;
  width: auto;
`

export const DesktopLink = styled(Link)`
  @media (max-width: 768px) {
    display: none;
  }
`

export const MobileLink = styled(Link)`
  @media (min-width: 767px) {
    display: none;
  }
`